'use es6';

import { createAction } from 'redux-actions';
import actionTypes from '../constants/actionTypes';
import { fetchAIAccessControls } from 'reporting-discover-components/api/genaiApi';
const aiSettingsRequested = createAction(actionTypes.AI_SETTINGS_REQUESTED);
const aiSettingsSucceeded = createAction(actionTypes.AI_SETTINGS_SUCCEEDED);
const aiSettingsFailed = createAction(actionTypes.AI_SETTINGS_FAILED);
export const getAIAccessSettings = () => dispatch => {
  dispatch(aiSettingsRequested());
  return fetchAIAccessControls().then(({
    generativeAiEnabled,
    crmPropertiesEnabled
  }) => {
    dispatch(aiSettingsSucceeded({
      generativeAiEnabled,
      crmPropertiesEnabled
    }));
  }).catch(() => {
    dispatch(aiSettingsFailed());
  });
};